import Pbf from 'pbf';
import * as P from './proto.map.js';
export function pbufMapDecoder(buffer) {
    var pbf = new Pbf(buffer);
    return P.readMap(pbf);
}
